module.exports = __webpack_public_path__ + "img/logo-bmkg.29e743e8.png";